<template>
    <div>
        <!--供应商对账-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form inline :label-width="100">
                        <FormItem label="当前供应商：" style="margin-right: 30px">
                            <router-link to="" @click.native="isShowDrawer=true"><strong style="color: #00a1ff">{{SupplierName}}</strong>
                                <Icon size="26" color="#00a1ff" type="md-arrow-dropright" style="position: relative;top:4px;"/>
                            </router-link>
                        </FormItem>
                        <FormItem label="单据类型：" style="margin-right: 30px">
                            <Select style="width: 200px"
                                    placeholder="全部单据"
                                    v-model="Bill"
                                    @on-change="getDebtList(page,rows,valuedate[0],valuedate[1],SupplierId)">
                                <Option value="">全部单据</Option>
                                <Option :value="0">非欠款单据</Option>
                                <Option :value="1">欠款单据</Option>
                                <Option :value="2">付款单据</Option>

                            </Select>
                        </FormItem>
                        <FormItem label="选择时间：" style="margin-right: 30px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="handleOk"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem label="总欠款：" style="margin-right: 30px">
                            <div><strong class="result">{{overdrawMonery}}</strong>
                                <Button type="warning" @click="payMoneyModal=true"
                                        style="position: relative;top: 0px;left: 20px">付款
                                </Button>
                            </div>
                        </FormItem>
                        <!-- 导出 -->
                        <FormItem>
                            <Button type="primary" @click="exportExcel(valuedate[0],valuedate[1],SupplierId)">导出</Button>
                        </FormItem>
                    </Form>
                </Col>
                <!--<Col span="6" align="right">
                    <Col span="6"  style="position: relative;top: -6px;">总欠款: <strong class="result">{{overdrawMonery}}</strong></Col>
                    <Col span="10"  ><Button type="warning" @click="payMoneyModal=true" style="position: relative;top: -8px;" >付款</Button></Col>
                </Col>-->
            </Row>
        </header>
        <Row style="margin: 0px 0 20px">
            <Col span="5" offset="3">交易金额: <strong class="result">{{resultMoney.shouldmoney}}</strong></Col>
            <Col span="5">实付金额: <strong class="result">{{resultMoney.truemoney}}</strong></Col>
            <Col span="5">应付余额: <strong class="result">{{resultMoney.surplusbalance}}</strong></Col>

        </Row>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" size="small" @click="goDetail(row)">详情</Button>
            </template>
        </Table>

        <div class="pageTotal">
            <Page :total="pageTotal"
                  show-total
                  :page-size="rows"
                  @on-change="onChangePage"/>
        </div>


        <!--供应商对账列表-->
        <Drawer title="供应商对账" :closable="false" v-model="isShowDrawer" width="400">
            <Input search enter-button placeholder="供应商名称" style="margin-bottom: 20px" v-model="DrawerNames"/>
            <Input search enter-button placeholder="供应商电话" style="margin-bottom: 20px" v-model="phone"/>
            <Alert type="warning" v-if="SupplierList.length==0">未查询到数据</Alert>
            <Row v-if="SupplierList.length!=0">
                <Col span="8" align="center"><h3>全部供应商</h3></Col>
                <Col span="8" align="center"><h3>应付供应商</h3></Col>
                <Col span="8" align="center"><h3>应付金额</h3></Col>
                <Col span="8" align="center"><strong>{{SupplierData.totalNum}}</strong></Col>
                <Col span="8" align="center"><strong>{{SupplierData.num}}</strong></Col>
                <Col span="8" align="center">
                    <strong v-if="SupplierData.money==null">0</strong>
                    <strong v-else>{{SupplierData.money}}</strong>
                </Col>
            </Row>
            <Card dis-hover class="supplierList" v-for="(k, v) in SupplierList" :key="v"
                  @click.native="modifySupplierName(k,v)">
                <Row>
                    <Col span="16"><h3>{{ k.name }}</h3></Col>
                    <Col span="8"><h3>欠款</h3></Col>
                    <Col span="16">联系电话:{{ k.phone }}</Col>
                    <Col span="8">
                        <strong style="color: #ff5e5e" v-if=" k.money>0">{{ k.money }}</strong>
                        <strong v-else>{{ k.money }}</strong>
                    </Col>
                </Row>
            </Card>
            <div class="pageTotal">
                <Page :total="DrawerNamesPage.currpage"
                      show-total
                      :page-size="DrawerNamesPage.rows"
                      @on-change="onGongPageTotal"/>
            </div>
        </Drawer>
        <!--付款-->
        <Modal
                v-model="payMoneyModal"
                title="供应商结算">
            <Form :label-width="100" inline>
                <FormItem label="供应商" class="payMoneyModal-input">
                    <strong>{{SupplierName}}</strong>
                </FormItem>
                <FormItem label="欠供应商款" class="payMoneyModal-input">
                    <strong>{{overdrawMonery}}</strong>
                </FormItem>
                <FormItem label="结算类型：" class="payMoneyModal-input">
                    <strong>采购支出</strong>
                </FormItem>
                <FormItem label="业务时间：" class="payMoneyModal-input">
                    <strong>{{this.nowTime}}</strong>
                </FormItem>
                <FormItem label="结算账户：">
                    <Select style="width: 300px" v-model="BankListValue">
                        <Option v-for="(item,index) in bankList"
                                v-if="!item.bankname.includes('会员')"
                                :value="item.id"
                                :key="index" placeholder="请选择">{{item.bankname}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="本次付款：">
                    <Input v-model="thisTruemoney" style="width: 300px"/>
                </FormItem>

                <FormItem label="备注：">
                    <Input type="textarea" v-model="fuKanMsg" style="width: 300px"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="payMoneyModal=false">取消</Button>
                <Button type="primary" @click="payOk()">确认</Button>
            </div>
        </Modal>
        <!--详情-->
        <Modal
                v-model="detailModal"
                width="800"
                title="供应商结算详情">
            <Form :label-width="100" inline>
                <FormItem label="供应商：" class="payMoneyModal-input">
                    <strong>{{SupplierName}}</strong>
                </FormItem>
                <FormItem label="门店：" class="payMoneyModal-input">
                    <strong>{{doorShip}}</strong>
                </FormItem>
                <FormItem label="操作人：" class="payMoneyModal-input">
                    <strong>{{detailModalData.operator}}</strong>
                </FormItem>
                <FormItem label="结算账户：" class="payMoneyModal-input">
                    <strong>{{detailModalData.bankName}}</strong>
                </FormItem>
                <FormItem label="结算类型：" class="payMoneyModal-input">
                    <strong>{{detailModalData.tableType}}</strong>
                </FormItem>
                <FormItem label="业务时间：">
                    <strong>{{detailModalData.time}}</strong>
                </FormItem>
                <FormItem label="总欠款：" class="payMoneyModal-input">
                    <strong>{{detailModalData.surplusSmoneys+detailModalData.actualMoney}}</strong>
                </FormItem>
                <FormItem label="本次付款：" class="payMoneyModal-input">
                    <strong>{{detailModalData.actualMoney}}</strong>
                </FormItem>
                <FormItem label="尚欠款：" class="payMoneyModal-input">
                    <strong>{{ detailModalData.surplusSmoneys}}</strong>
                </FormItem>
                <FormItem label="单号：">
                    <strong>{{detailModalData.order}}</strong>
                </FormItem>
                <FormItem label="备注：" style=" display: block">
                    <strong>{{detailModalData.remark}}</strong>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="detailModal=false">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import { exportExcel } from '@/common/exportExcel';
    export default {
        data() {
            return {
                cid: '',
                sid: '',
                page: 1,
                rows: 11,
                pageTotal: 0,
                index: 0,
                isShowDrawer: false,
                payMoneyModal: false,
                detailModal: false,
                isShowPage: false,
                detailModalData: {},
                SupplierList: [],
                Bill: 0,
                phone:'',
                doorShip: JSON.parse(localStorage.getItem('shop')).name,
                SupplierName: '',//供应商名称
                SupplierId: null,//供应商id
                overdrawMonery: 0,
                resultMoney: {},
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                columns: [
                    {title: '表单类型', key: 'tableType', align: 'center'},
                    {title: '单据类型', key: 'buyType', align: 'center'},
                    {title: '操作人', key: 'operator', align: 'center'},
                    {title: '时间', key: 'time', align: 'center'},
                    {title: '单号', key: 'order', align: 'center', width: '220'},
                    {title: '应付金额', key: 'payMoney', align: 'center'},
                    {title: '实付金额', key: 'actualMoney', align: 'center'},
                    {title: '应付余额', key: 'surplusSmoney', align: 'center'},
                    {title: '操作', key: 'edit', align: 'center', slot: 'action',},
                ],
                data: [],
                BankList: [], //结算账户列表
                BankListValue: null,
                fuKanMsg: '',
                loadingTable: true,
                thisTruemoney: 0,
                DrawerNamesPage: {
                    currpage: 0,
                    page: 1,
                    rows: 7
                },
                DrawerNames: '',
                SupplierData: {},
            };
        },
        watch: {
            'DrawerNames': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getSupplierList(this.index, this.DrawerNamesPage.page, this.DrawerNamesPage.rows)
                }
            },
            'phone': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getSupplierList(this.index, this.DrawerNamesPage.page, this.DrawerNamesPage.rows)
                }
            },
        },
        created: function () {
            //获取用户信息
            this.cid = JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.getDay(-7)
            this.valuedate[1] = this.nowTime
            this.getSupplierList(this.index, this.DrawerNamesPage.page, this.DrawerNamesPage.rows)
            this.getBankList()//银行卡列表
            this.getSupplierData()
        },

        methods: {
            exportExcel(startTime,endTime,customerid) {
                const params = {
                    cid: this.cid,
                    sid: this.sid,
                    status: 1,
                    state: this.Bill,
                    time: startTime,
                    endtime: endTime,
                    customerid: customerid,          
            };
            exportExcel(this.$Api.exportDebtList, params, this.$Message, new Date().toLocaleString() + '供应商对账');
        },
            getDay(day) {
                var today = new Date();
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();
                var tMonth = today.getMonth();
                var tDate = today.getDate();
                tMonth = this.doHandleMonth(tMonth + 1);
                tDate = this.doHandleMonth(tDate);
                return tYear + "-" + tMonth + "-" + tDate;
            },
            doHandleMonth(month) {
                var m = month;
                if (month.toString().length == 1) {
                    m = "0" + month;
                }
                return m;
            },

            //供应商列表
            getSupplierList(index, page, row) {
                this.$Api.getSupplierList({
                    cid: this.cid,
                    sid: this.sid,
                    name: this.DrawerNames,
                    page: page,
                    rows: row,
                    isdel: 1,
                    phone:this.phone,
                }).then(res => {
                    if (res.code == 200) {
                        this.SupplierList = res.data
                        this.DrawerNamesPage.currpage = res.count
                        this.SupplierName = this.SupplierList[index].name
                        this.SupplierId = this.SupplierList[index].id
                        this.overdrawMonery = this.SupplierList[index].money
                        this.thisTruemoney = this.SupplierList[index].money
                        this.getDebtList(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
                        this.getSumDebt(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            getSupplierData() {
                this.$Api.getSupplierData({
                    sid: this.sid,
                }).then(res => {
                    if (res.code == 200) {
                        this.SupplierData = res.data
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //修改供应商
            modifySupplierName(item, v) {

                this.index = v
                this.SupplierName = item.name
                this.SupplierId = item.id
                this.overdrawMonery = item.money
                this.isShowDrawer = false
                this.getDebtList(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
                this.getSumDebt(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
            },

            //供应商单据列表
            getDebtList(page, rows, startTime, endTime, customerid) {
                /* if(this.Bill==0){
                     this.Bill=''
                 }*/
                this.$Api.getDebtList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    status: 1,
                    state: this.Bill,
                    time: startTime,
                    endtime: endTime,
                    customerid: customerid,
                }).then(res => {
                    if (res.code == 200) {
                        this.data = []
                        this.pageTotal = res.count

                        if (this.pageTotal >= 11) {
                            this.isShowPage = true
                        } else {
                            this.isShowPage = false
                        }
                        res.data.forEach((item, index) => {
                            var PurchaseList = {}
                            PurchaseList.tableType = item.statusName
                            if (item.state !== '2') {
                                PurchaseList.payMoney = item.shouldmoney
                                PurchaseList.surplusSmoney = item.surplusbalance
                            } else {
                                PurchaseList.payMoney = '----'
                                PurchaseList.surplusSmoney = '----'
                            }
                            PurchaseList.buyType = item.stateName
                            PurchaseList.surplusSmoneys = item.surplusbalance
                            PurchaseList.bankName = item.bankName,
                                PurchaseList.id = item.ids,
                                PurchaseList.operator = item.adminname,
                                PurchaseList.time = item.time,
                                PurchaseList.order = item.code,
                                PurchaseList.actualMoney = item.truemoney,
                                PurchaseList.remark = item.remark,
                                this.data.push(PurchaseList)
                        })
                        this.loadingTable = false
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });

            },

            getSumDebt(page, rows, startTime, endTime, customerid) {
                if (this.Bill == 0) {
                    this.Bill = ''
                }
                this.$Api.getSumDebt({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    status: 1,
                    state: this.Bill,
                    time: startTime,
                    endtime: endTime,
                    customerid: customerid,
                }).then(res => {
                    if (res.code == 200) {
                        if (res.data != null) {
                            this.resultMoney = res.data
                        } else {
                            this.resultMoney.shouldmoney = 0
                            this.resultMoney.truemoney = 0
                            this.resultMoney.surplusbalance = 0
                        }
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            handleOk(data) {
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.getDebtList(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
                this.getSumDebt(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
            },

            goDetail(item) {
                if (item.id == null) {
                    this.detailModal = true
                    this.detailModalData = item
                } else {

                    this.$router.push(
                        {
                            path: '/historyDetail',
                            query: {
                                id: item.id
                            }
                        })

                    // this.$router.push(
                    //     {
                    //     path:'/supplierDetail',
                    //     query:{
                    //         id:item.id
                    //     }
                    // })
                }

            },

            //获取银行卡
            getBankList() {
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if (res.code == 200) {
                        this.bankList = res.data
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //分页
            onChangePage(num) {
                this.getDebtList(num, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
            },
            onGongPageTotal(num) {
                this.getSupplierList(this.index, num, this.DrawerNamesPage.rows)
            },
            //付款确认
            payOk() {

               if(this.BankListValue==''||this.BankListValue==null){
                   this.$Message.warning('请选择结算账户');return
               }
                this.$Api.addDebt({
                    cid: this.cid,
                    sid: this.sid,
                    bankid: this.BankListValue,//银行卡ID
                    customerid: this.SupplierId,//供应商id
                    tradetypeid: 2,
                    status: 1,
                    surplusbalance: this.overdrawMonery,//应付**
                    truemoney: this.thisTruemoney,//实收金额
                    adminid: JSON.parse(localStorage.getItem('adminUser')).id,
                    remark: this.fuKanMsg
                }).then(res => {
                    if (res.code == 200) {
                        this.$Message.success('付款成功');
                        this.payMoneyModal = false
                        this.getDebtList(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
                        this.getSumDebt(this.page, this.rows, this.valuedate[0], this.valuedate[1], this.SupplierId)
                        this.getSupplierList(this.index, this.DrawerNamesPage.page, this.DrawerNamesPage.rows)
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },


        }
    };
</script>

<style lang="scss" scoped>
    .form-title {
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }

    .result {
        color: #ff5e5e;
    }

    .supplierList {
        background: #bfdeff;
        margin-top: 20px;
        border-left: 5px solid #ff7f7f;
        cursor: pointer;
    }

    .payMoneyModal-input {
        width: 230px;
    }

</style>